import { createLink } from '@tanstack/react-router'
import type { VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'
import { buttonVariants } from '../ui/button'

function ActionAnchor({
  variant = 'default',
  size = 'sm',
  className,
  ...props
}: ComponentProps<'a'> & VariantProps<typeof buttonVariants>) {
  return <a className={buttonVariants({ variant, size, className })} {...props} />
}

export const ActionLink = createLink(ActionAnchor)
